import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { PHONE_DISPLAY, WHATSAPP_NUMBER } from "../data/content";

const LINKS = [
  { id: "inicio", label: "Início", testid: "nav-link-home" },
  { id: "servicos", label: "Serviços", testid: "nav-link-services" },
  { id: "antes-depois", label: "Antes & Depois", testid: "nav-link-before-after" },
  { id: "clientes", label: "Clientes", testid: "nav-link-clients" },
  { id: "sobre", label: "A Gold", testid: "nav-link-about" },
  { id: "orcamento", label: "Orçamento", testid: "nav-link-quote" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => () => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={go("inicio")}
          className="flex items-center gap-3 group"
        >
          <img
            src="/images/logo.webp"
            alt="Gold Service"
            className="h-9 w-9 sm:h-11 sm:w-11 rounded-full object-cover ring-1 ring-gold/50 transition-transform duration-500 group-hover:rotate-6"
          />
          <span className="font-display font-bold tracking-tight text-sm sm:text-base leading-none text-left">
            Gold <span className="gold-text">Service</span>
            <span className="block text-[9px] sm:text-[10px] font-body font-medium tracking-[0.22em] uppercase text-mist mt-0.5">
              Controle Integrado
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={go(l.id)}
              className="text-sm font-medium text-mist hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            data-testid="header-phone-cta"
            href={`tel:+${WHATSAPP_NUMBER}`}
            className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-gold-light border border-gold/30 rounded-full px-4 py-2 hover:bg-gold/10 transition-colors duration-300"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-white/15 text-zinc-200"
            aria-label="Abrir menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-4 py-4 flex flex-col">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-${l.testid}`}
                onClick={go(l.id)}
                className="text-left font-display font-semibold text-lg py-3 border-b border-white/5 text-zinc-100 active:text-gold"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="mobile-phone-cta"
              href={`tel:+${WHATSAPP_NUMBER}`}
              className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-gold text-ink font-bold py-3"
            >
              <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
